const ITEMS_LIST_FILTERS_STORAGE_PREFIX = "items_list_filters_";

export const buildItemsListFiltersStorageKey = (storageKey: string): string =>
  `${ITEMS_LIST_FILTERS_STORAGE_PREFIX}${storageKey}`;

/**
 * Deleted records are hidden by default, so anything unreadable/missing in
 * storage falls back to false.
 */
export const loadShowDeletedFromStorage = (storageKey: string): boolean => {
  try {
    const stored = localStorage.getItem(
      buildItemsListFiltersStorageKey(storageKey),
    );

    return stored === "true";
  } catch {
    return false;
  }
};

export const saveShowDeletedToStorage = (
  storageKey: string,
  showDeleted: boolean,
): void => {
  try {
    localStorage.setItem(
      buildItemsListFiltersStorageKey(storageKey),
      String(showDeleted),
    );
  } catch {}
};

/**
 * Hides soft-deleted items unless the user asked to see them. Lists without a
 * deleted predicate are returned untouched.
 */
export const applyDeletedFilter = <TItem>(
  items: TItem[],
  isDeleted: ((item: TItem) => boolean) | undefined,
  showDeleted: boolean,
): TItem[] => {
  if (!isDeleted || showDeleted) {
    return items;
  }

  return items.filter((item) => !isDeleted(item));
};
